import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

import ChevronDownIcon from 'static/images/sidebar/chevron-down.svg';

function ChatOrganizationItemContent({ 
  organization, 
  childOrganizations,  
  selectedsOrganizations,
  showRightIcon,
  isActive,
  handleClickOrganization, 
  handleSelectOrganization,
}) {
  const organizationItem = { 
    organization, 
    childOrganizations 
  };

  const itemClassName = useMemo(() => {
    if (!showRightIcon) 
      return 'org-list-item-content';
    
    if (childOrganizations && isActive(organization)) {
      return 'org-list-item-content active has-children';
    } 
    
    if (childOrganizations) {
      return 'org-list-item-content has-children';
    }

    return 'org-list-item-content';
  }, [isActive, organization, childOrganizations]);

  return (
    <div  
      data-testid={`organization-item-content-${organization.key}`}
      className={itemClassName}
    >
      <input 
        data-testid={`organization-item-checkbox-${organization.key}`}
        className={`${selectedsOrganizations.includes(organization) ? 'checked' : ''}`}
        type="checkbox" 
        onChange={() => handleSelectOrganization(organizationItem)} 
        checked={selectedsOrganizations.includes(organization)}
      />
      <div
        data-testid={`organization-item-dropdown-zone-${organization.key}`} 
        onClick={() => handleClickOrganization(organization)}
      >
        <div className="info">
          <p className="name">{organization.description}</p>
          <p className="region">{organization?.timeZone?.timezoneName || '--'}</p>
        </div>
        {childOrganizations && showRightIcon && (
          <img src={ChevronDownIcon} alt="Chevron Down Icon" /> 
        )}
      </div>
    </div>
  );
}

ChatOrganizationItemContent.propTypes = {
  organization: PropTypes.object.isRequired,
  childOrganizations: PropTypes.array,
  selectedsOrganizations: PropTypes.array.isRequired,
  showRightIcon: PropTypes.bool,
  isActive: PropTypes.func.isRequired,
  handleClickOrganization: PropTypes.func.isRequired,
  handleSelectOrganization: PropTypes.func.isRequired
};

export default memo(ChatOrganizationItemContent);